import { useContext } from "react"
import { GeometryContext } from "../store/store"
import {useSelector} from 'react-redux'
import {Float, Text} from '@react-three/drei'

const BlockStart = ({position = [0,0,0]}) => {
    const geometryCtx = useContext(GeometryContext)
    // const geometryState = useSelector((state)=>state.geometry)
  return (
    <group position={position}>
      <Float floatIntensity={0.25} rotationIntensity={0.25}>
        <Text 
          scale={4}
          font='./bebas-neue-v9-latin-regular.woff'
          maxWidth={0.25}
          lineHeight={0.75}
          textAlign='right'
          position={[0.75,0.65,0]}
          rotation-y={-0.25}
        >
          Marble Race
          <meshBasicMaterial toneMapped={false}/>
        </Text>
      </Float>
        <mesh 
            geometry={geometryCtx.boxGeometry} 
            material={geometryCtx.floor1Material} 
            position={[0,-0.1,0]} 
            receiveShadow 
            scale={[4,0.2,4]}
        />
            
        
    </group>
  )
}

export default BlockStart